<template>
  <div class="search-counties">
    <div
      v-if="displayDropdown"
      class="search-counties__overlay"
      @click="clearSearch">
    </div>

    <div class="search-counties__fields">
      <search-field-input
        :value.sync="city"
        label="I vilket område?"
        name="county"
        placeholder="Skriv kommun eller län"
        @update:value="findCity">
        <template>
          <ul class="search-counties__results" v-if="hasFoundCities">
            <li
              v-for="city in foundCities"
              :key="city.path"
              class="search-counties__results-item"
              @click="addLocation(city)">
              <strong>{{ city.name }}</strong> <span v-if="city.__typename === 'Municipality'">kommun</span>
            </li>
          </ul>

          <ul
            v-if="noResults"
            class="search-counties__results search-counties__results--no-results">
            <li class="search-counties__no-results-item">
              Tyvärr finns inte det område du söker
            </li>
          </ul>
        </template>
      </search-field-input>
    </div>
  </div>
</template>

<script>
import SearchFieldInput from './SearchFieldInput'
import gql from 'graphql-tag'
import * as types from '@/store/actionTypes'

export default {
  name: 'SearchLocations',
  components: {
    SearchFieldInput
  },

  data() {
    return {
      city: '',
      foundCities: []
    }
  },

  computed: {
    hasFoundCities() {
      return this.foundCities.length > 0 && this.city.length > 0
    },
    noResults() {
      return this.foundCities.length === 0 && this.city.length > 0
    },
    displayDropdown() {
      return this.hasFoundCities || this.noResults
    }
  },

  apollo: {
    counties: {
      query: gql`
        query getCounties {
          counties {
            name
            path
            municipalities {
              path
              name
            }
          }
        }
      `
    }
  },

  methods: {
    clearSearch() {
      this.city = ''
      this.foundCities = []
    },
    findCity() {
      if (!this.counties) {
        return
      }

      // This turns the whole counties array into one big array of arrays
      this.foundCities = this.counties
        .map(county => {
          return [
            {
              name: county.name,
              path: county.path,
              __typename: county.__typename
            },
            ...county.municipalities
          ]
        })
        .reduce((acc, curr) => {
          // This reduces the big array of arrays into one array
          return acc.concat(curr)
        }, [])
        .filter(({ name }) => {
          // This finds what we're searching for, in both counties and municipalities
          return name.toLowerCase().includes(this.city.toLowerCase())
        })
        .sort(a => {
          if (a.__typename === 'Municipality') {
            return -1
          }
          return 1
        })
    },
    addLocation({ name, path }) {
      const payload = { name, path }

      this.$store.commit(types.ADD_TO_QUERY, {
        payload,
        type: 'city'
      })

      window.eventBus.$emit('openExpansionPanel', { ...payload, type: 'city' })

      this.clearSearch()
    }
  }
}
</script>

<style lang="postcss" scoped>
@import '../../variables/custom-media.css';

.search-counties {
  position: relative;
  -ms-grid-column: 1;
  -ms-grid-row: 2;

  @media (--ie11) and (--bp-desktop) {
    -ms-grid-column: 2;
    -ms-grid-row: 1;
    margin-right: 20px;
  }
}

.search-counties__overlay {
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
}

.search-counties__fields {
  position: relative;
  z-index: 2;
}

.search-counties__results {
  background-color: white;
  border-radius: 4px;
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.08);
  left: 0;
  margin-top: var(--spacing-third);
  max-height: 300px;
  overflow: auto;
  position: absolute;
  right: 0;
}

.search-counties__results-item {
  cursor: pointer;
  padding: var(--spacing-third);

  &:not(:last-child) {
    border-bottom: 1px solid var(--color-geyser);
  }

  &:hover {
    background-color: var(--color-concrete);
  }
}

.search-counties__no-results-item {
  color: var(--color-silver-chalice);
  padding: var(--spacing-third);
}
</style>



// WEBPACK FOOTER //
// src/views/Search/SearchLocations.vue